import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: #0f0f0f;
`;

export const FooterWrap = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  line-height: 1.6;

  @media screen and (max-width: 640px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 24px;

  /* When layout switches to vertical, allow link groups to wrap into two columns */
  @media screen and (max-width: 640px) {
    flex-wrap: wrap;
    justify-content: left;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px;
  text-align: center;
  width: 160px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 640px) {
    margin: 8px 16px;
    width: calc(50% - 32px);
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 14px;
  margin-bottom: 16px;
`;

export const FooterCtaBlock = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 24px 16px;

  @media screen and (max-width: 768px) {
    padding: 0 0 16px;
  }
`;

export const FooterCtaLabel = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #f7f8fa;
  text-align: center;
`;

export const FooterCtaButton = styled.a`
  border-radius: 50px;
  background: #ffcb66;
  white-space: nowrap;
  padding: 12px 20px;
  width: auto;
  max-width: 100%;
  text-align: center;
  font-size: clamp(15px, 4vw, 16px);
  letter-spacing: 0.01em;
  min-width: 220px;
  max-width: 360px;
  color: #010606;
  outline: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
  }
`;

export const FooterLink = styled.a`
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;

  &:hover {
    color: #ffcb66;
    transtion: 0.3s ease-out;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  line-height: 1.6;
  max-width: 1100px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled(Link)`
  color: #fff;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
  width: 10rem;
  flex: 0 0 auto;
`;

export const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 16px;
  text-align: center;
  flex: 1 1 auto;

  @media screen and (max-width: 640px) {
    order: 3;
    width: 100%;
    margin-top: 8px;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 160px;
  flex: 0 0 auto;
  @media screen and (max-width: 640px) {
    justify-content: center;
    order: 4;
    width: 100%;
  }
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 28px;
  margin-bottom: 16px;
  padding-right: 20px;
`;

export const Logo = styled.img`
  width: 100%;
  margin: 0 0 0 0;
  padding-right: 0;
`;
